import cx from 'classnames';

import styles from './Noz.module.scss';

interface NozProps {
	size?: number;
	className?: string;
}

/**
 * Noz — the SigNoz AI assistant mascot. Waves on hover.
 *
 * Hover behavior:
 *  - Hovering the icon itself triggers the wave.
 *  - To make a parent element (e.g. a Button) trigger the wave on its own
 *    hover, add the class `noz-wave` to that parent.
 */
export default function Noz({ size = 24, className }: NozProps): JSX.Element {
	return (
		<span
			className={cx(styles.noz, className)}
			style={{ width: size, height: size }}
			aria-hidden="true"
		>
			<svg
				viewBox="-2 0.5 28 28"
				width={size}
				height={size}
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				{/* body */}
				<rect
					x="4.35938"
					y="8.49908"
					width="15.4569"
					height="11.978"
					rx="1.76147"
					fill="#E5484D"
				/>
				{/* legs */}
				<rect
					x="6.87012"
					y="19.0679"
					width="3.34679"
					height="3.69908"
					rx="0.880734"
					fill="#E5484D"
				/>
				<rect
					x="13.916"
					y="19.0679"
					width="3.34679"
					height="3.69908"
					rx="0.880734"
					fill="#E5484D"
				/>
				{/* right arm (static) */}
				<rect
					x="18.7598"
					y="13.4752"
					width="2.11376"
					height="3.69908"
					rx="0.880734"
					fill="#E5484D"
				/>
				{/* left arm: outer group does the "lift", inner does the wiggle */}
				<g className="noz-arm-left">
					<g className="noz-arm-wiggle">
						<rect
							x="3.12695"
							y="13.4752"
							width="2.11376"
							height="3.69908"
							rx="0.880734"
							fill="#E5484D"
						/>
					</g>
				</g>
				{/* head: face + eye + hat tilt together */}
				<g className="noz-head">
					<circle cx="12.0217" cy="14.4881" r="3.87523" fill="#F5F5F5" />
					<path
						d="M12.0237 12.8024C12.0237 13.7328 11.2673 14.4892 10.337 14.4892C10.0339 14.4892 9.74926 14.4101 9.50152 14.2678C9.47517 14.5551 9.49888 14.8502 9.57795 15.1428C9.93901 16.4921 11.3279 17.2933 12.6773 16.9323C14.0267 16.5712 14.8279 15.1823 14.4668 13.8329C14.1453 12.6285 13.0041 11.8616 11.8023 11.967C11.942 12.2121 12.0237 12.4967 12.0237 12.8024Z"
						fill="#0A0C10"
					/>
					<path
						d="M8.33833 7.94578L9.83358 4.31319C10.1302 3.59261 10.6676 2.99939 11.355 2.63299L13.9181 1.26684C14.1327 1.15169 14.3804 1.34885 14.3194 1.58439L13.6703 4.06892C13.6511 4.14046 13.6424 4.21374 13.6424 4.28876C13.6424 4.39868 13.6633 4.5086 13.7052 4.61154L15.0382 7.94578H11.4248L11.6307 7.32813L12.3356 7.09259C12.449 7.05421 12.5257 6.94778 12.5257 6.82739C12.5257 6.707 12.449 6.60057 12.3356 6.56218L11.6307 6.32664L11.3951 5.62176C11.3568 5.51009 11.2503 5.43333 11.1299 5.43333C11.0096 5.43333 10.9031 5.5101 10.8647 5.6235L10.6292 6.32839L9.92431 6.56393C9.8109 6.60231 9.73413 6.70874 9.73413 6.82913C9.73413 6.94952 9.8109 7.05595 9.92431 7.09434L10.6292 7.32988L10.8351 7.94752H8.33833V7.94578ZM12.1 3.43558C12.0808 3.378 12.0285 3.33962 11.9674 3.33962C11.9064 3.33962 11.854 3.378 11.8348 3.43558L11.7179 3.78802L11.3655 3.90492C11.3079 3.92411 11.2695 3.97645 11.2695 4.03752C11.2695 4.09859 11.3079 4.15093 11.3655 4.17012L11.7179 4.28702L11.8348 4.63946C11.854 4.69704 11.9064 4.73542 11.9674 4.73542C12.0285 4.73542 12.0808 4.69704 12.1 4.63946L12.2169 4.28702L12.5694 4.17012C12.6269 4.15093 12.6653 4.09859 12.6653 4.03752C12.6653 3.97645 12.6269 3.92411 12.5694 3.90492L12.2169 3.78802L12.1 3.43558ZM7.78 7.91088H15.5965C15.9053 7.91088 16.1548 8.16038 16.1548 8.4692C16.1548 8.77803 15.9053 9.02753 15.5965 9.02753H7.78C7.47118 9.02753 7.22168 8.77803 7.22168 8.4692C7.22168 8.16038 7.47118 7.91088 7.78 7.91088Z"
						fill="#4E74F8"
					/>
				</g>
			</svg>
		</span>
	);
}

Noz.defaultProps = {
	size: 24,
	className: undefined,
};
